import Select from "react-select";

const styles = {
  control: (base, state) => ({
    ...base,
    minHeight: 46,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: state.isFocused ? "var(--ops-accent-strong)" : "transparent",
    background: state.isFocused ? "var(--ops-surface)" : "var(--ops-surface-soft)",
    boxShadow: state.isFocused ? "0 0 0 3px var(--ops-accent-tint)" : "none",
    transition: "border-color 0.15s, box-shadow 0.15s, background 0.15s",
    "&:hover": { borderColor: state.isFocused ? "var(--ops-accent-strong)" : "var(--ops-border-strong)" },
  }),
  valueContainer: (base) => ({ ...base, padding: "2px 14px" }),
  input: (base) => ({ ...base, color: "var(--ops-ink)", fontFamily: "inherit", fontSize: 14 }),
  singleValue: (base) => ({ ...base, color: "var(--ops-ink)", fontFamily: "inherit", fontSize: 14 }),
  placeholder: (base) => ({ ...base, color: "var(--ops-muted-soft)", fontSize: 14 }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({ ...base, color: "var(--ops-muted)" }),
  clearIndicator: (base) => ({ ...base, color: "var(--ops-muted)" }),
  menu: (base) => ({
    ...base,
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "var(--ops-shadow-md)",
    border: "1px solid var(--ops-border)",
    zIndex: 20,
  }),
  menuList: (base) => ({ ...base, padding: 6 }),
  option: (base, state) => ({
    ...base,
    borderRadius: 8,
    fontSize: 14,
    fontFamily: "inherit",
    color: "var(--ops-ink)",
    background: state.isSelected ? "var(--ops-accent-tint)" : state.isFocused ? "var(--ops-surface-soft)" : "transparent",
    cursor: "pointer",
  }),
  noOptionsMessage: (base) => ({ ...base, fontSize: 13, color: "var(--ops-muted)" }),
  loadingMessage: (base) => ({ ...base, fontSize: 13, color: "var(--ops-muted)" }),
};

export function SearchSelect({
  inputId,
  options,
  value,
  onChange,
  placeholder = "Search…",
  isClearable = true,
  isLoading = false,
  isDisabled = false,
  noOptionsMessage = "No results found",
}) {
  const selected = options.find((option) => option.value === value) || null;

  return (
    <Select
      inputId={inputId}
      classNamePrefix="ops-rselect"
      options={options}
      value={selected}
      onChange={(option) => onChange(option ? option.value : "")}
      placeholder={placeholder}
      isClearable={isClearable}
      isLoading={isLoading}
      isDisabled={isDisabled}
      styles={styles}
      noOptionsMessage={() => noOptionsMessage}
    />
  );
}
